// extracted by mini-css-extract-plugin
module.exports = {"name":"formatters_name__2NPwA","name__link":"formatters_name__link__2SVem","name__link__name":"formatters_name__link__name__2Q5NA"};